import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { ResultOfT } from '../models/response/result';
import { ActivityLogService } from '../services/activity-log.service';
import { BackgroundService } from '../services/background.service';
import { WebStorageService } from '../services/web-storage.service';
import { BaseComponent } from '../shared/base.component';

@Component({
  selector: 'app-background-service-status',
  templateUrl: './background-service-status.component.html',
  styleUrls: ['./background-service-status.component.sass']
})
export class BackgroundServiceStatusComponent extends BaseComponent implements OnInit {
  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();

  OCRServiceStatus: string = 'Fetching';
  RecycleBinServiceStatus: string = 'Fetching';

  constructor(private backgroundService: BackgroundService) {
    super();
  }

  ngOnInit(): void {
    this.getOCRStatus();
    this.getRecycleBinStatus();
  }

  getOCRStatus() {
    this.backgroundService.getOCRServiceStatus()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<string>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel && result.ResponseModel.length > 0) {
              this.OCRServiceStatus = result.ResponseModel;
              this.loading = false;
            }
          }
          else {
            this.loading = false;
            this.OCRServiceStatus = 'Error';
          }
        });
      }, (httpResponseError) => {
        this.OCRServiceStatus = 'Error';
      });
  }

  getRecycleBinStatus() {
    this.backgroundService.getRecycleBinServiceStatus()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<string>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel && result.ResponseModel.length > 0) {
              this.RecycleBinServiceStatus = result.ResponseModel;
              this.loading = false;
            }
          }
          else {
            this.loading = false;
            this.RecycleBinServiceStatus = 'Error';
          }
        });
      }, (httpResponseError) => {
        this.RecycleBinServiceStatus = 'Error';
      });
  }


  
}
